{
  "upload": {
    "absent": {
      "text": "Non hai licenze attive."
    },
    "text": "Carica il file di licenza",
    "title": "Fai clic qui per selezionare e caricare un file di licenza",
    "dropInformation": "Carica qui la licenza o fai clic qui per avviare la selezione",
    "validation": {
      "fileMandatory": "Il file deve essere un .JWT o un .OPL",
      "fileEmpty": "Il file non deve essere vuoto",
      "fileSize": "La dimensione del file deve essere inferiore a 750 MB"
    },
    "new": {
      "text": "Caricare un nuovo file di licenza",
      "title": "Fai clic qui per selezionare e caricare un nuovo file di licenza"
    },
    "loading": "Caricamento in corso...",
    "success": "Licenza valida",
    "errors": {
      "signature_invalid": "È stato rilevato un errore di firma nel file di licenza.",
      "license_id_already_exists": "L'identificatore della licenza è lo stesso della licenza attuale.",
      "platform_id_not_match": "L'identificatore della piattaforma non corrisponde.",
      "organization_id_not_match": "L'identificatore dell'organizzazione non corrisponde.",
      "expires_contracted_invalid": "La data di scadenza è precedente alla data corrente.",
      "expires_tolerate_invalid": "La data di scadenza non corrisponde al valore previsto.",
      "max_devices_total_value_invalid": "Il numero totale di apparati non corrisponde al valore previsto.",
      "max_devices_total_contracted_expires_invalid": "Il numero di apparati è inferiore al valore corrente per l'organizzazione.",
      "max_devices_total_tolerated_expires_invalid": "Il numero totale di apparati non corrisponde al valore previsto.",
      "max_devices_by_type_value_invalid": "Il numero totale di apparati non corrisponde al valore previsto.",
      "max_devices_by_type_contracted_expires_invalid": "Il numero di apparati è inferiore al valore corrente per l'organizzazione.",
      "max_devices_by_type_tolerated_expires_invalid": "Il numero totale di apparati non corrisponde al valore previsto.",
      "feature_value_invalid": "Le caratteristiche della licenza non corrispondono al valore previsto.",
      "schema_not_match": "È stato rilevato un errore di formato del file di licenza relativo alle seguenti informazioni: {field}"
    }
  },
  "status": {
    "title": "Stato della licenza:",
    "active": "Attiva",
    "notActive": "Non ancora attiva",
    "warning": "Avviso",
    "expired": "Scaduta"
  },
  "characteristics": {
    "title": "Caratteristiche",
    "date": {
      "validated": "Data di validità:",
      "validatedOn": "Approvata il {date}",
      "start": "Data di avviamento:",
      "end": "Data di scadenza:"
    },
    "id": "ID licenza:"
  },
  "idCard": {
    "title": "Informazioni necessarie per ottenere una licenza",
    "description": "Questi identificativi sono utilizzati per generare le licenze.",
    "export": {
      "title": "Esportare la carta ID",
      "text": "Esportare la carta ID"
    },
    "download": "Scarica la carta d'identità"
  },
  "overlay": {
    "title": {
      "notFound": "La tua organizzazione richiede una licenza",
      "expired": "La tua licenza è scaduta"
    },
    "message": {
      "notFound": "Per gestire la tua organizzazione, carica una licenza. L'accesso sarà bloccato finché non sarà stata caricata una licenza valida.",
      "expired": "Per continuare a gestire la tua organizzazione, rinnova la licenza. L'accesso è provvisoriamente bloccato finché la situazione non viene risolta."
    }
  },
  "gauge": {
    "device": {
      "warning": {
        "tooltip": "È stato raggiunto il numero di apparati autorizzati dalla licenza",
        "message": "Soglia raggiunta"
      },
      "error": {
        "tooltip": "Impossibile aggiungere altri apparati alla piattaforma",
        "message": "Limite raggiunto"
      }
    }
  },
  "deviceTypes": {
    "title": "Soglie apparato"
  },
  "withoutLimits": "Senza limite",
  "total": "Totale",
  "features": {
    "title": "Limiti di licenza",
    "interfaces_third_party": "Interfacce",
    "warning": {
      "tooltip": "Hai superato il limite della licenza"
    },
    "error": {
      "tooltip": "La creazione di nuove risorse è disabilitata"
    }
  },
  "warning": {
    "title": "Limite della licenza raggiunto.",
    "expirationDateExceeded": "Hai superato la data di scadenza della licenza. Ti preghiamo di rinnovare la licenza prima dell'interruzione del servizio.",
    "devicesCountExceeded": "È stato superato il numero consentito di apparati per la licenza attuale. Alcune funzionalità possono essere limitate fino a quando il problema non viene risolto.",
    "redirect": "Visualizza pannello licenze"
  }
}
